import langLogin from '@views/login/lang/en'
import langAuthority from '@views/authority/lang/en'
import langAdmin from '@views/admin/lang/en'
import userHome from '@views/home/lang/en'
import parentLogin from '@views/parentLogin/lang/en'
import user from '@views/user/lang/en'

export default {
  message: {
    'hello': 'hello,world'
  },
  home: {
    moduleClose: 'Module not open',
    tips1: 'Please scan the QR code and follow our school\'s WeChat offical account for the latest news.'
  },
  button: {
    printing: 'Print',
    sendMssage: 'Send Message',
    sendMssageText1: 'Admission Notice',
    sendMssageText2: 'Resubmit Notice',
    retBtn: 'Reset',
    serBtn: 'Search',
    seniorSerBtn: 'Advanced Search',
    more: 'More',
    addBtn: 'Add',
    upload: 'Upload',
    updBtn: 'Modify',
    dltBtn: 'Delete',
    returnBtn: 'Back',
    ediBtn: 'Edit',
    cncBtn: 'Cancle',
    surBtn: 'Confirm',
    submitBtn: 'Confirm',
    laststep: 'Previous',
    next: 'Next',
    Savenextstep: 'Save/Next step',
    complete: 'Complete',
    savBtn: 'Save',
    submission: 'Sumbit',
    enableFlag: 'Available',
    operation: 'Operation',
    questionnaire: 'Send Questionnaire',
    import: 'Import',
    export: 'Export',
    or: 'Or',
    copy: 'Copy',
    addadvisoryBtn: 'Add Inquiry',
    close: 'Close',
    Lateradd: 'Add later ',
    Immediatelyadd: 'Add immediately',
    Submitimmediately: 'Submit immediately',
    approved: 'Approved',
    giveUp: 'Decline',
    checkAll: 'Select all',
    returnSchool: 'Back to school overview',
    returnIndex: 'Back to home page',
    dialogMessageCnc: 'Reselect',
    dialogMessageSurBtn: 'Confirm to send',
    addBtnTip: 'Add',
    dltBtnTip: 'Delete',
    logInNow: 'Login now',
    yyaccount: 'Have an account',
    backPage: 'Back to login page'
  },
  search: {},
  fromMsg: {
    printing: 'Print',
    handoverSuccess: 'Switch Successfully！',
    mailHost: 'SMTP Sever',
    mailSmtpPort: 'Please enter the port',
    mailUsername: 'Please enter the user name',
    mailPassword: 'Please enter the password',
    smsAccessKeyId: 'SMS Key Id',
    smsAccessKeySecret: 'SMS Key',
    appId: 'Please enter the APP ID',
    appSecret: 'Please enter the key',
    key: 'Please enter the payment key',
    mchId: 'Please enter the commercial tenant ID',
    encodingAesKey: 'Please enter the WeChat public number to send message',
    token: 'Please enter WeChat public number to push message token',
    appIdOpen: 'WeChat Open Platform APPID',
    appSecretOpen: 'WeChat Open Platform Key',
    qrCodePath: 'Please upload WeChat account QR code',
    certPath: 'Please upload WeChat payment certificate',
    certPathZq: 'Please upload the correct payment certificate',
    mailTemplate: 'Please edit the email content firstly!',
    mailTemplatetit: 'Email Template',
    mailSubject: 'Email subject',
    parentPhone: 'Please enter the contact tel',
    noteNull: 'The contents cannot be empty!',
    phoneNull: 'The mobile no. cannot be empty!',
    passwordNull: 'The password cannot be empty!',
    newPasswordNull: 'The confirmed password cannot be empty!',
    passwordMistaken: 'The password entered doesn\'s match!',
    getPassword: 'Please get the correct SMS verification code!',
    originalPwdX: 'Please enter the original password',
    newPwdPwdX: 'Please enter the new password',
    newPwdPwdF: 'Please enter the confirmed password',
    phone: 'Please enter a valid mobile no.！',
    email: 'Please enter a valid email',
    getCode: 'Get code',
    getCode2: 'Get code',
    getCodeRepeat: 'Resend',
    codeYZ: 'Please get the correct SMS verification code!',
    inquiryContent: 'Please enter the inquiry contents',
    gradeId: 'Please select the current grade',
    parentName: 'Please enter the contact name',
    recommendSource: 'Please select the recommended source',
    uploadImg: 'Supports JPG, PNG format only',
    code: 'Please enter the verification code',
    citizenship: 'Please enter the nationality',
    firstName: 'Please enter the first name',
    lastName: 'Please enter the last name',
    gender: 'Please select gender.',
    smsCode: 'Please enter the SMS verification code',
    passwordX: 'Please enter the password',
    passwordF: 'Please enter the confirmed password',
    atypism: 'The passwords donot match',
    actionUser: 'Please enter the name',
    schoolName: 'Applying School',
    gradeName: 'Applying Grade',
    tourDate: 'Visit Date',
    startTime: 'Visit Time',
    maxRemain: 'Remaining places',
    maxCount: 'Max no. of visitors per time',
    remark: 'Remark',
    picPath: 'Please upload a picture',
    nationality: 'Please select nationality',
    firstNameLength: 'Length between 1 and 20 characters',
    lastNameLength: 'Length between 1 and 20 characters',
    fullName: 'Please enter the full name',
    fullNameLength: 'Length between 1 and 40 characters',
    firstNameSpell: 'Please enter the first name (pinyin)',
    firstNameSpellLength: 'Length between 1 and 20 characters',
    lastNameSpell: 'Please enter the last name (pinyin)',
    lastNameSpelllLength: 'Length between 1 and 20 characters',
    birthday: 'Please select the day of birth',
    sex: 'Please select the gender',
    credentialsType: 'Please select the ID type',
    credentialsNumber: 'Please enter the ID number',
    credentialsNumberLength: 'Length between 1 and 20 characters',
    surveyNameZh: 'Please enter the Chinese name of the questionnaire',
    surveyNameEn: 'Please enter the English name of the questionnaire',
    surveyremark: 'Please enter the questionnaire description',
    closingDate: 'Please select the deadline',
    questionType: 'Please select the question type',
    questionNameZh: 'Please enter the Chinese description',
    questionNameEn: 'Please enter the English description',
    studentName: 'Please select a student',
    examgradeId: 'Please select the grade',
    examDateId: 'Please select the exam date',
    examLocation: 'Please enter the exam room',
    examRemark: 'Please enter the time instruction of the exam subject',
    linkmanName: 'Please enter the contact name',
    examPaySuccess: 'Paid successfully！',
    tourDateId: 'Please select the visit date',
    tourTime: 'Please select the visit time',
    tourCount: 'Please enter the visitor no.',
    tourMaxTotal: 'Please enter the max visitor no.',
    tourMaxCount: 'Please enter the max no. of individual application',
    tourAddRemark: 'Please enter the additional information',
    surveyId: 'Please enter the questionnaire',
    theVisit: 'Do you want to cancel the tour?',
    linkmanPhone: 'Please enter the contact mobile',
    linkmanEmail: 'Please enter the contact email',
    SelectedVisiting: 'The visitor no. is greater than the upper limit',
    studentsNo: 'No student seleted',
    Unfilled: 'Not completed',
    UnfilledNuber: 'Visitor no. is empty',
    education: 'Please enter the education',
    linkmanNameJ: 'Please enter the emergency contact name',
    relationshipJ: 'Please enter an emergency contact relationship',
    linkmanPhoneJ: 'Please enter the emergency contact mobile no.',
    linkmanEmailJ: 'Please enter the emergency contact email',
    emailZ: 'Please enter the email for receiving the admission ticket',
    Nofiletype: 'Please select file type',
    NotourDateId: 'Please select visit date',
    NoexamgradeId: 'Please select grade',
    Noselection: 'Please select applying grade',
    Noexamination: 'Please select exam date',
    examEditTypes1: 'Exam status change',
    examEditTypes2: 'Acceptance status change',
    mailY: 'Post',
    ExtractionY: 'Collection',
    paymentType: 'Please select payment type',
    acceptType: 'Please select the collection method',
    postName: 'Please enter the recipient name',
    postCode: 'Please enter the postal code',
    postAddress: 'Please enter the address',
    acceptDate: 'Please select the Collection date',
    acceptTime: 'Please select the Collection time',
    confirmexam: 'Are you sure to cancel the exam?',
    Tips: 'Tips',
    codename: 'Please enter the type name',
    codevalue: 'Please enter the type number',
    sortOptions1: 'Upper level type name',
    sortOptions2: 'Type Name',
    sortOptions3: 'Type Code',
    effective: 'Vaild',
    Invalid: 'Invaild',
    Uploadingfile: 'Upload',
    nationalityId: 'Nationality ID',
    surveyquestions: 'Some survey questions were not selected.',
    tourCountZq: 'Please enter the correct visitor no.',
    responsibleperson: 'Please select the owner.',
    beforesave: 'Exist Incomplet Questions',
    NoRecord: 'Please improve your past school records',
    AddedSuccessfully: 'Added Successfully',
    labelName: 'Tag name can not be empty！',
    newLabelName: 'New signature can not be empty！',
    Studentinformation: 'Please set up the student information file firstly！',
    noTour: 'There is no tour arrangement for the grade. Please call admission office！',
    noExam: 'There is no exam arrangement for the grade. Please call admission office！',
    TimeDownBefore: 'Completed and return in ',
    TimeDownAfter: ' seconds',
    submitSuccess: 'Submitted successfully！',
    consultSubmitSuccess: 'Your consultation has been submitted, the teacher will contact you as soon as possible！',
    tourTip: 'The student has incomplete  visit applications!',
    examTip: 'The student has ncomplete exam applications!',
    appTip: 'The student had admission applications already !',
    addTip: 'The max no. of contact is three.',
    validInt: 'Please enter a valid number',
    menuNameZh: 'Please enter the Menu Chinese Name',
    menuNameEn: 'Please enter the Menu English Name',
    menuCode: 'Please enter the code',
    menuUrl: 'Please enter the url',
    roleNameEn: 'Please enter the Role English Name',
    roleNameZh: 'Please enter the Role Chinese Name'
  },
  confirm: {
    type: 'Tips',
    deleterecord: 'Are you sure you want to delete this record?',
    message: 'Are you sure you want to delete this message?',
    theVisit: 'Do you want to cancel the visit?',
    cancelExam: 'Do you want to cancel the exam?',
    updateDate: 'Confirm to change the date?',
    abandon: 'Are you sure to decline the acceptance?',
    questionnaireExpired: 'The questionnaire has expired',
    changeTip: 'Are you sure to do this?'
  },
  langLogin: langLogin,
  langAuthority: langAuthority,
  langAdmin: langAdmin,
  userHome: userHome,
  parentLogin: parentLogin,
  user: user,
  cropper: {
    uploadPictures: 'Upload',
    uploadAgain: 'Re-upload',
    resetImage: 'Reset',
    cancel: 'Cancel',
    determine: 'Confirm',
    tips1: 'Format error, supports image format：JPG、JPEG、PNG',
    tips2: 'The file size is less than 5M '
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js